import { createBrowserRouter, RouteObject } from 'react-router-dom';
import MentorDashboard from '../features/alumni/mentorship/MentorDashboard';
import MentorMentees from '../features/alumni/mentorship/MentorMentees';
import MentorMessages from '../features/alumni/mentorship/MentorMessages';
import MentorSessions from '../features/alumni/mentorship/MentorSessions';
import MentorProfile from '../features/alumni/mentorship/MentorProfile';
import MenteeLanding from '../features/alumni/mentorship/mentee/MenteeLanding';
import MenteeDashboard from '../features/alumni/mentorship/mentee/MenteeDashboard';
import MenteeMyMentor from '../features/alumni/mentorship/mentee/MenteeMyMentor';
import MenteeSessions from '../features/alumni/mentorship/mentee/MenteeSessions';
import MenteeRegistration from '../features/alumni/mentorship/mentee/MenteeRegistration';
import MentorshipModuleSettings from '../features/management/mentorship/MentorshipModuleSettings';
import routes from './routes';

export const managementMentorshipRoute: RouteObject = {
    path: 'mentorship/module-settings',
    loader: async () => {
        document.title = 'Mentorship';
        return null;
    },
    element: <MentorshipModuleSettings />,
};

export const mentorshipRoute: RouteObject = {
    path: 'mentorship',
    children: [
        {
            path: 'dashboard',
            loader: async () => {
                document.title = 'Mentorship Dashboard';
                return null;
            },
            element: <MentorDashboard />,
        },
        {
            path: 'mentees',
            loader: async () => {
                document.title = 'My Mentees';
                return null;
            },
            element: <MentorMentees />,
        },
        {
            path: 'messages',
            loader: async () => {
                document.title = 'Messages';
                return null;
            },
            element: <MentorMessages />,
        },
        {
            path: 'sessions',
            loader: async () => {
                document.title = 'Sessions & Scheduling';
                return null;
            },
            element: <MentorSessions />,
        },
        {
            path: 'profile',
            loader: async () => {
                document.title = 'My Profile';
                return null;
            },
            element: <MentorProfile />,
        },
        {
            path: 'mentee',
            children: [
                {
                    index: true,
                    loader: async () => {
                        document.title = 'Mentors';
                        return null;
                    },
                    element: <MenteeLanding />,
                },
                {
                    path: 'dashboard',
                    loader: async () => {
                        document.title = 'Mentee Dashboard';
                        return null;
                    },
                    element: <MenteeDashboard />,
                },
                {
                    path: 'mentor',
                    loader: async () => {
                        document.title = 'My Mentor';
                        return null;
                    },
                    element: <MenteeMyMentor />,
                },
                {
                    path: 'sessions',
                    loader: async () => {
                        document.title = 'Sessions';
                        return null;
                    },
                    element: <MenteeSessions />,
                },
                {
                    path: 'register',
                    loader: async () => {
                        document.title = 'Mentee Registration';
                        return null;
                    },
                    element: <MenteeRegistration />,
                },
            ],
        },
    ],
};

/** Inject mentorship routes under `/alumni` and `/management` when not already present. */
export const applyMentorshipRoutes = (routeTree: RouteObject[]): RouteObject[] => {
    const [alumniTree, ...otherRoutes] = routeTree;
    const alumniChild = alumniTree.children?.find((child) => child.path === 'alumni');
    if (alumniChild?.children && !alumniChild.children.some((child) => child.path === 'mentorship')) {
        const dashboardIndex = alumniChild.children.findIndex((child) => child.path === 'dashboard');
        const insertAt = dashboardIndex >= 0 ? dashboardIndex + 1 : 0;
        alumniChild.children.splice(insertAt, 0, mentorshipRoute);
    }

    const managementParent = routeTree.find((route) => route.path === '/management');
    if (
        managementParent?.children &&
        !managementParent.children.some((child) => child.path === 'mentorship/module-settings')
    ) {
        const profileAnalyticsIndex = managementParent.children.findIndex(
            (child) => child.path === 'profile-analytics-dashboard',
        );
        const insertAt =
            profileAnalyticsIndex >= 0 ? profileAnalyticsIndex + 1 : managementParent.children.length;
        managementParent.children.splice(insertAt, 0, managementMentorshipRoute);
    }

    return [alumniTree, ...otherRoutes];
};

const router = createBrowserRouter(applyMentorshipRoutes(routes as RouteObject[]));

export default router;
